import ConnectedClassificationPage from "./ConnectedClassificationPage";
import ConnectedClassificationPageContent from "./ConnectedClassificationPageContent";
import ConnectedClassifications from "./ConnectedClassifications";
import ConnectedSubmit from "./ConnectedSubmit";

export {
    ConnectedClassificationPageContent,
    ConnectedClassifications,
    ConnectedSubmit,
};

export default ConnectedClassificationPage;
